import * as React from 'react';
import {
  Box,
  StackLayout,
  TextAction,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { Link } from 'react-router-dom';
import type {
  StatusReportTableRowDetails,
  StatusReportTableRowStatus,
} from '../status-report-table-row.types';
import { getStatusReportCellCss } from './get-status-report-cell-css';

/**
 * Renders the details table cell for the resolved column value.
 * Can include a secondary message and contextual link.
 */
export const StatusReportDetailsCell = ({
  value,
  rowStatus,
}: {
  value: StatusReportTableRowDetails;
  rowStatus?: StatusReportTableRowStatus;
}) => {
  if (rowStatus === 'error') {
    return (
      <Box as="td" css={getStatusReportCellCss('details')}>
        <StackLayout spacing="$quarter" css={{ minWidth: 0 }}>
          <Box
            css={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '$quarter',
            }}
          >
            <UtilityText
              as="span"
              size="base"
              css={{ color: '$onSurfaceTextCritical' }}
            >
              {value.text}
            </UtilityText>
            {value.link && (
              <TextAction
                as={Link}
                to={value.link.path}
                target="_blank"
                rel="noopener noreferrer"
                indicator={value.link.indicator}
                css={{
                  fontWeight: '$normal',
                  textDecoration: value.link.underlined
                    ? 'underline'
                    : undefined,
                }}
              >
                {value.link.label}
              </TextAction>
            )}
          </Box>
          {value.secondaryText && (
            <UtilityText emphasis="subtle" size="xs">
              {value.secondaryText}
            </UtilityText>
          )}
        </StackLayout>
      </Box>
    );
  }

  return (
    <Box as="td" css={getStatusReportCellCss('details')}>
      <UtilityText
        emphasis={rowStatus === 'loading' ? 'subtle' : undefined}
        size="base"
      >
        {value.text}
      </UtilityText>
    </Box>
  );
};
